import { Check, X } from "lucide-react";
import { INCLUSIONS, EXCLUSIONS, IMAGES } from "../data/tour";
import { Reveal, SectionHead } from "./Reveal";

export const Inclusions = () => (
  <section id="inclusions" data-testid="inclusions-section" className="mx-auto max-w-7xl px-6 py-28 lg:px-10">
    <SectionHead index="02" overline="No Fine Print" title="Exactly what's in — and what's not." />

    <div className="mt-16 grid grid-cols-1 gap-px bg-vine lg:grid-cols-12">
      <Reveal className="lg:col-span-5">
        <div className="h-full bg-jungle p-10">
          <p className="text-[11px] uppercase tracking-[0.3em] text-marigold">Included in every package</p>
          <ul className="mt-8 space-y-4" data-testid="inclusions-list">
            {INCLUSIONS.map((item) => (
              <li key={item} className="flex items-start gap-3 border-b border-vine pb-4 text-sm leading-relaxed text-cream/90">
                <Check size={16} className="mt-0.5 shrink-0 text-marigold" />
                {item}
              </li>
            ))}
          </ul>
        </div>
      </Reveal>

      <Reveal delay={0.1} className="lg:col-span-4">
        <div className="h-full bg-jungle p-10">
          <p className="text-[11px] uppercase tracking-[0.3em] text-sage">Not included</p>
          <ul className="mt-8 space-y-4" data-testid="exclusions-list">
            {EXCLUSIONS.map((item) => (
              <li key={item} className="flex items-start gap-3 border-b border-vine pb-4 text-sm leading-relaxed text-sage">
                <X size={16} className="mt-0.5 shrink-0 text-sage/60" />
                {item}
              </li>
            ))}
          </ul>
        </div>
      </Reveal>

      <Reveal delay={0.2} className="lg:col-span-3">
        <div className="relative h-full min-h-[320px] overflow-hidden">
          <img src={IMAGES.hotel} alt="3-star stay" className="absolute inset-0 h-full w-full object-cover" data-testid="inclusions-stay-image" />
          <div className="absolute inset-0 bg-gradient-to-t from-jungle via-jungle/30 to-transparent" />
          <div className="absolute bottom-0 p-8">
            <p className="font-serif text-2xl italic leading-snug text-cream">
              Sleep well at every halt — 3-star comfort, always.
            </p>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
